































































































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import { analyzeImages } from 'guardian-liveness-detection-lib/src/libs/toImages'
import 'vue-loading-overlay/dist/vue-loading.css'
import * as Sentry from '@sentry/browser'

import store from '@/store'
import { getReport, sendReport } from '@/lib/report'
import { invalidTokenCheckAndHandler } from '@/lib/invalidTokenCheckAndHandler'
import { takeVideoHandler } from '@/lib/process-flow/takeVideo'
import { loadHandler } from '@/lib/process-flow/load'
import { checkHandler, CheckResultType } from '@/lib/process-flow/check'
import { resolveHandler } from '@/lib/process-flow/resolve'
import { uploadHandler } from '@/lib/process-flow/upload'
import DialogPrompt from '@/views/common/DialogPrompt.vue'

interface IFileObj {
  file: File,
  video?: HTMLVideoElement
}

interface IResolveResult {
  file?: Blob[],
  videoFileFullName?: string,
  videoDuration?: number,
  videoOrigFormat?: string,
  videoOrigSize?: number,
  videoOrigWidth?: number,
  videoOrigHeight?: number,
  isResolved?: boolean,
  resolvedSize?: number,
  resolvedWidth?: number,
  resolvedHeight?: number,
  resolveTime?: number,
  videoResolvedFormat?: string,
  videoResolvedSize?: number,
  errorMsg?: string,
}

interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
}

// tslint:disable-next-line
const Loading = require('vue-loading-overlay')
// Maximum acceptable video
const MAX_SIZE = 5 * 1024 * 1024  // byte

@Component({
  components: {
    Loading,
    DialogPrompt,
    [Button.name]: Button,
  },
})

export default class Home extends Vue {
  preparing: boolean = false
  loading: boolean = false
  bizToken: any = null
  isAllowUpload: boolean = true

  videoElement: null | HTMLVideoElement = null
  dialogPromiseResolveFunc: any = null
  resolveFile: Blob[] = []
  resolveResult: null | IResolveResult = null
  videoBasicInfo: any = null
  videoMetaData: undefined | HTMLVideoElement = undefined
  compressedFile: any = null
  uploadResult: null | IUploadResult = null

  // dialog
  browserVersionTooLow: boolean = false
  lengthTooLongHint: boolean = false
  lengthTooShortHint: boolean = false
  formatNotSupportHint: boolean = false
  uploadFailedHint: boolean = false
  metadataAuthorizationHint: boolean = false
  resolveFailedHint: boolean = false
  unresolvedVideoSizeTooBigHint: boolean = false

  // judge is support asyncIterator
  isAsyncAwaitSupport() {
    const func = {}
    try {
      const evalIsBadAvoidThis = eval
      evalIsBadAvoidThis('func = async function(){}')
    } catch (e) {
      return false
    }
    return Object.getPrototypeOf(func).constructor !== null
  }

  preCheckBrowserVersion() {
    if (!this.isAsyncAwaitSupport()) {
      this.browserVersionTooLow = true
      this.sendReportPreCheck(false, 'NOT_SUPPORT_BROWSER_VERSION')
      return
    }
    this.startHandler()
  }

  async startHandler() {
    try {
      // step1 - take video
      // console.log('take video......')
      const file = await takeVideoHandler()
      // console.log('file', file)


      // step2 - load
      // console.log('loading......')
      this.preparing = true
      const loadFile = await loadHandler(file, this.loadTimeoutHandler)
      this.preparing = false
      this.metadataAuthorizationHint = false
      // console.log('loadFile', loadFile)


      // step3 - check
      // console.log('pre checking......')
      this.loading = true
      const checkFile = await checkHandler(loadFile)
      switch (checkFile.type) {
        case CheckResultType.FILE_SUFFIX_NOT_MATCH:
          this.formatNotSupportHint = true
          this.sendReportPreCheck(false, 'UNACCEPTED_SUFFIX', checkFile.fileObj, false)
          return
        case CheckResultType.DURATION_TOO_SHORT:
          this.lengthTooShortHint = true
          this.sendReportPreCheck(false, 'UNACCEPTED_DURATION', checkFile.fileObj, false)
          return
        case CheckResultType.DURATION_TOO_LONG:
          this.lengthTooLongHint = true
          this.sendReportPreCheck(false, 'UNACCEPTED_DURATION', checkFile.fileObj, false)
          return
        case CheckResultType.UPLOAD_DIRECTLY:
          this.videoMetaData = checkFile.fileObj.video
          await this.overtakeMaximumSizeReject(checkFile.fileObj.file.size, checkFile.fileObj)
          await this.uploadStep({ file: checkFile.fileObj.file })
          return
      }
      // console.log('checkFile', checkFile.fileObj)


      // step4 - resolve
      // normal && checkFile.type === 'NEED_RESOLVE',
      // console.log('compressing......')
      // console.log('file origin size', `${file.size / 1024}k`)

      try {
        const resolveStartTime = new Date().getTime()
        this.resolveFile = await resolveHandler(checkFile.fileObj.video as HTMLVideoElement)
        // console.log('resolve file', this.resolveFile)
        this.compressedFile = analyzeImages(this.resolveFile)
        // console.log('compressed size', this.compressedFile)
        this.resolveResult = {
          videoFileFullName: checkFile.fileObj.file.name,
          videoDuration: checkFile.fileObj.video ? checkFile.fileObj.video.duration : 0,
          videoOrigFormat: checkFile.fileObj.file.type,
          videoOrigSize: checkFile.fileObj.file.size,
          videoOrigWidth: checkFile.fileObj.video ? checkFile.fileObj.video.videoWidth : 0,
          videoOrigHeight: checkFile.fileObj.video ? checkFile.fileObj.video.videoHeight : 0,
          isResolved: this.resolveFile instanceof Array ? true : false,
          resolveTime: new Date().getTime() - resolveStartTime,
          videoResolvedFormat: this.compressedFile.dataType === 'image/webp' ? 'webp' : 'jpeg',
          videoResolvedSize: this.compressedFile.size * 1024,
        }
      } catch (error) {
        console.error(error)
        if (error.message === 'To Images Timeout') {
          await this.overtakeMaximumSizeReject(
            checkFile.fileObj.file.size,
            checkFile.fileObj,
            'RESOLVE_FAILED',
          )
          await this.uploadStep({ file: checkFile.fileObj.file })
          return
        }
        this.resolveFailedHint = true
        Sentry.captureException(error)
        this.sendReportResolve(false, error.message, this.resolveResult || {}, false)
        return
      }

      // step5 - upload
      await this.overtakeMaximumSizeReject(this.compressedFile.size * 1024)
      await this.uploadStep({ images: this.resolveFile })
    } catch (error) {
      console.error(error)
      // load or get file failed *
      this.resolveFailedHint = true
      Sentry.captureException(error)
      this.sendReportResolve(false, error.message, this.resolveResult || {}, false)
      return
    } finally {
      this.loading = false
    }
  }


  async uploadStep(payload: { file?: File, images?: Blob[]}) {
    try {
      // console.log('uploading......')
      const uploadStartTime = new Date().getTime()
      const uploadReturnData = await uploadHandler(payload, this.bizToken)
      const uploadResult = {
        code: uploadReturnData.code,
        message: uploadReturnData.message,
        transactionId: uploadReturnData.transactionId,
        score: uploadReturnData.data ? uploadReturnData.data.score : 0,
        uploadTime: new Date().getTime() - uploadStartTime,
        tryCount: uploadReturnData.data ? uploadReturnData.data.tryCount : 0,
        returnUrl: uploadReturnData.data ? uploadReturnData.data.returnUrl : '',
      }
      this.uploadResult = uploadResult


      this.videoBasicInfo = {
        videoFileFullName: payload.file ? payload.file.name : '',
        videoDuration: this.videoMetaData ? this.videoMetaData.duration : 0,
        videoOrigFormat: payload.file ? payload.file.type : '',
        videoOrigSize: payload.file ? payload.file.size : 0,
        videoOrigWidth: this.videoMetaData ? this.videoMetaData.videoWidth : 0,
        videoOrigHeight: this.videoMetaData ? this.videoMetaData.videoHeight : 0,
        isResolved: false,
      }

      // if is invalid token, direct to result page
      if (invalidTokenCheckAndHandler(uploadResult.code as string)) {
        return
      }

      // compressed failed -- time
      if (uploadResult.code === 'VIDEO_TIME_TOO_SHORT' || uploadResult.code === 'IMAGE_TOO_LITTLE') {
        this.resolveFailedHint = true
        this.sendReportUpload(true, 'ERROR_DURATION_AFTER_COMPRESSION', this.resolveResult || this.videoBasicInfo, uploadResult, false)
        return
      }

      if (uploadReturnData.code === 'SUCCESS') {
        this.sendReportUpload(true, uploadResult.message, this.resolveResult || this.videoBasicInfo, uploadResult, true)
      } else {
        this.sendReportUpload(false, uploadResult.message, this.resolveResult || this.videoBasicInfo, uploadResult, true)
      }

      // console.log('upload success')
      this.pageJumpHandler(uploadReturnData)
    } catch (error) {
      console.error(error)
      this.resolveFailedHint = true
      Sentry.captureException(error)
      this.sendReportUpload(false, error.messages, this.resolveResult || this.videoBasicInfo, this.uploadResult || {}, false)
      return
    }
  }

  pageJumpHandler(data: any) {
    this.$router.push({
      name: 'result',
      query: {
        result: data.code,
        message: data.message,
        score: data.data ? `${data.data.score}` : '',
        returnUrl: data.data ? data.data.returnUrl : '',
      },
    })
  }

  // authorize metadata manually
  loadTimeoutHandler(el: HTMLVideoElement): Promise<void> {
    return new Promise((resolve, reject) => {
      this.metadataAuthorizationHint = true
      this.preparing = false
      this.videoElement = el
      this.dialogPromiseResolveFunc = resolve
    })
  }

  uploadDialogHandler() {
    this.dialogPromiseResolveFunc()
    this.metadataAuthorizationHint = false
    if (!this.videoElement) {
      return
    }
    this.videoElement.load()
  }

  // More than 5M front end refuse upload
  overtakeMaximumSizeReject(size: number, fileObjInfo?: IFileObj, errorType?: string) {
    return new Promise<void>((resolve, reject) => {
      if (size > MAX_SIZE) {
        console.warn('file size more than 5M')
        this.loading = false
        if (errorType === 'RESOLVE_FAILED') {
          this.resolveFailedHint = true
          this.sendReportPreCheck(false, 'UNSUPPORTED_COMPRESSION_TYPE', fileObjInfo, false)
          return
        } else if (fileObjInfo && !errorType) {
          this.resolveFailedHint = true
          return this.sendReportPreCheck(false, 'UNACCEPTED_SIZE', fileObjInfo, false)
        } else {
          this.unresolvedVideoSizeTooBigHint = true
          return this.sendReportUpload(false, 'UNACCEPTED_RESOLVED_SIZE', this.resolveResult || this.videoBasicInfo, this.uploadResult || {}, false)
        }
        return
      }
      resolve()
    })
  }

  sendReportPreCheck(result: boolean, message: string, fileObj?: IFileObj, isJump?: boolean) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'PRE_CHECK'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.videoFileFullName = fileObj ? fileObj.file.name : ''
    reportDetail.videoDuration = fileObj && fileObj.video ? fileObj.video.duration : 0
    reportDetail.videoOrigFormat = fileObj ? fileObj.file.type : ''
    reportDetail.videoOrigSize = fileObj ? fileObj.file.size : 0
    sendReport(report, message, isJump)
  }

  getReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.videoFileFullName = resolveResult.videoFileFullName
    reportDetail.videoDuration = resolveResult.videoDuration
    reportDetail.videoOrigFormat = resolveResult.videoOrigFormat
    reportDetail.videoOrigSize = resolveResult.videoOrigSize
    reportDetail.videoOrigWidth = resolveResult.videoOrigWidth
    reportDetail.videoOrigHeight = resolveResult.videoOrigHeight

    reportDetail.isResolved = resolveResult.isResolved
    reportDetail.resolveTime = resolveResult.resolveTime
    reportDetail.videoResolvedFormat = resolveResult.videoResolvedFormat
    reportDetail.videoResolvedSize = resolveResult.videoResolvedSize

    return report
  }

  sendReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    sendReport(this.getReportResolve(result, message, resolveResult, isJump))
  }

  sendReportUpload(result: boolean, message: string, resolveResult: IResolveResult, uploadResult: IUploadResult, isJump?: boolean) {
    const report = this.getReportResolve(result, message, resolveResult)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    reportDetail.uploadTime = uploadResult.uploadTime
    reportDetail.transactionId = uploadResult.transactionId
    reportDetail.score = uploadResult.score
    reportDetail.tryCount = uploadResult.tryCount,
    reportDetail.returnUrl = uploadResult.returnUrl,
    sendReport(report, message, isJump)
  }

  hideDialogHandler() {
    this.lengthTooLongHint = false
    this.lengthTooShortHint = false
    this.formatNotSupportHint = false
    this.uploadFailedHint = false
    this.metadataAuthorizationHint = false
    this.browserVersionTooLow = false
    this.resolveFailedHint = false
    this.unresolvedVideoSizeTooBigHint = false
  }

  fixedShunt() {
    // 100% PV to new version
    const newVersion = 10
    const defaultRandom = this.$route.query.ab_test || localStorage.getItem('abTestRandom')
    const abTestRandom = defaultRandom ? defaultRandom : Math.floor(Math.random() * 10 + 1)
    console.log('ab random', abTestRandom)
    localStorage.setItem('abTestRandom', `${abTestRandom}`)
    if (abTestRandom > newVersion) {
      this.$router.push({ name: 'homeV1', query: { biz_token: this.$route.query.biz_token } })
    }
  }

  mounted() {
    this.bizToken = this.$route.query.biz_token
    store.bizToken = this.$route.query.biz_token as string
    if (!this.bizToken) {
      this.isAllowUpload = false
      return
    }
    this.fixedShunt()
  }
}
